;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { DYNAMIC_FIELD_CONDITIONAL_REQUIRED_CONDITIONS } from '../lib/constants';

export interface IpCountry {
  id: string | number;
  iso_code: string;
  name: string;
  dial_code: string;
}

export interface CountryVatFormat {
  format: string;
  example: string;
  regex: string;
  label?: string;
}

export interface Country {
  id: number;
  name: string;
  dial_code: string;
  iso_code: string;
  iso_alpha_3_code: string;
  employeesCount: number;
  employable?: boolean;
  contractor_payable?: boolean;
  currency_id?: number;
  continent?: string;
  national_id_required?: boolean;
  has_permanent_contract?: boolean;
  has_fixed_contract?: boolean;
  allows_retroactive_employment?: boolean;
  country_guide_url?: string | null;
  vat_format?: CountryVatFormat;
}

export interface GetCountriesParams {
  contractor_payable?: boolean;
  employable?: boolean;
}

export interface CountryOption {
  id: string;
  name: string;
  value: string;
  image: {
    path: string;
    alt: string;
  };
  currencyId?: number;
  hasPermanentContract?: boolean;
  hasFixedContract?: boolean;
}

export interface USState {
  id: number;
  name: string;
  code: string;
}

export interface CountrySetupResponse {
  country_id: number;
  has_annual_leave: boolean;
  has_employment_info: boolean;
  has_public_holidays: boolean;
}

/**
 * A document that becomes required only when a sibling field's value matches.
 *
 * When `condition` is `"equals"` and the watched `field` equals `value`, the document
 * labelled `label` is treated as required (rendered in the required list and counted
 * toward the minimum upload requirement).
 *
 * Example — require a "TEE Registration Certificate" when `registered_with_tee` is `"yes"`.
 */
export interface CountryEmploymentDocumentRequiredWhenIn {
  label: string;
  field: string;
  condition: typeof DYNAMIC_FIELD_CONDITIONAL_REQUIRED_CONDITIONS.IN;
  value: string[];
}
export interface CountryEmploymentDocumentRequiredWhenEquals {
  label: string;
  field: string;
  condition: typeof DYNAMIC_FIELD_CONDITIONAL_REQUIRED_CONDITIONS.EQUALS;
  value: string;
}

export type CountryEmploymentDocumentRequiredWhen =
  | CountryEmploymentDocumentRequiredWhenIn
  | CountryEmploymentDocumentRequiredWhenEquals;
export interface CountryEmploymentDocumentsResponse {
  required: string[];
  optional: string[];
  forms?: string[];
  required_when?: CountryEmploymentDocumentRequiredWhen;
}
